import { useNavigate } from 'react-router-dom'
import Card from '../../public/components/Card'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaPen } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const ProjectCategoriesAdmin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderCard = item => (
        <Card
            key={item.id}
            imageSrc={item.header_image}
            buttonLabel={t('status.details')}
            onButtonClick={() => navigate(`/admin/auth/project-categories/${item.id}`)}
        >
            <h3>{item.title}</h3>
            <span className='text-sm text-gray-500'>{item.subtitle}</span>
            <p>{item.small_description}</p>
        </Card>
    )

    return (
        <EditableListPage
            title={t('navigation_admin.projects.categories')}
            endpoint='admin/project-categories'
            renderCard={renderCard}
            buttons={
                <Button
                    size='medium'
                    onClick={() => navigate('/admin/auth/project-categories/create')}
                >
                    <FaPen /> {t('status.create')}
                </Button>
            }
        />
    )
}

export default ProjectCategoriesAdmin
